import { parse, stringify } from 'query-string'
import _ from 'lodash'
import fp from 'lodash/fp'
// 1. getQueryStringObject 로 현재 queryString Object 얻는다.
// 2. delete, add, replace 는 각각 queryString Object 형태로 값을 리턴한다.
// 3. 처리가 끝난 queryString Object로 URL을 변경하여 상태를 변경한다.

// const queryStringProcessorBase = processFn => fp.flow(processFn)
const getQueryStringObject = () => parse(location.search)
const getValue = (path, defaultValue = '') => _.partial(fp.getOr, defaultValue, path, _.partial.placeholder)
const convertToQueryString = fp.flow(stringify, fp.thru(queryString => `?${queryString}`))
const deleteQueryByKeyFn = key => _.partial(fp.omit, key, _.partial.placeholder)
const setQueryByKeyFn = (key, val) => fp.set(key, val)

// input : object, delete key
// delete
const getRemovePropertyFromKeyFn = key => deleteQueryByKeyFn(key)
const getAddPropertyByKeyValueFn = (key, val) => setQueryByKeyFn(key, val)
const getReplaceQueryParamFn = (key, val) => setQueryByKeyFn(key, val)
const getValueFromQueryStringObjectFn = (path, defaultValue = '') => getValue(path, defaultValue)
const urlBuilder = (queryParamObj) => `${location.protocol}//${location.origin}${location.pathname}?${stringify(queryParamObj)}`
const relativeUrlBuilder = (queryParamObj) => `${location.pathname}?${stringify(queryParamObj)}`

const getQueryParamValue = (route, path, defaultValue = '') => _.get(route, ['query', path], defaultValue)

export default {
  getQueryStringObject,
  getValueFromQueryStringObjectFn,
  convertToQueryString,
  getRemovePropertyFromKeyFn,
  getAddPropertyByKeyValueFn,
  getReplaceQueryParamFn,
  urlBuilder,
  getQueryParamValue,
  relativeUrlBuilder
}
